module.exports = __webpack_public_path__ + "img/eye_sight_bad.8e26f42f.svg";